module.exports = __webpack_public_path__ + "4645e01b688b29f97d50489a0306bdaf.jpg";